import type { Migration } from "./Migration.js";
import type { ItemStoreState } from "@editor/items/ItemStore";
import type { StoreItem } from "@editor/items/StoreItem.js";

const migration: Migration = {
  applyToVersions: "<2.8.0",
  type: "before",
  name: "add the round start states",
  migrate: (
    data: {
      simulations?: ItemStoreState<SimulationItem>;
    }
    // options: {
    //   oldData?: {
    //     simulations?: {
    //       items: {
    //         [id: number]: { id: number; rounds: SimulationItem["rounds"] };
    //       };
    //     };
    //   };
    // }
  ) => {
    if (!data.simulations) return data;

    for (const simulationId in data.simulations.items) {
      const simulation = data.simulations.items[simulationId];

      const lastStartState = {
        resourceValues: simulation.startResourceValues || {},
        elementValues: simulation.startElementValues || {},
        indexValues: simulation.startIndexValues || {}
      };

      for (const round of simulation.rounds) {
        // If there's already a start state, abort.
        // This is the case if the migration was already run.
        if (round.startResourceValues) return data;

        round.startResourceValues = lastStartState.resourceValues;
        round.startElementValues = lastStartState.elementValues;
        round.startIndexValues = lastStartState.indexValues;

        lastStartState.resourceValues = round.resourceValues || {};
        lastStartState.elementValues = round.elementValues || {};
        lastStartState.indexValues = round.indexValues || {};
      }
    }

    return data;
  }
};

interface SimulationItem extends StoreItem {
  type: "simulation";

  startResourceValues: { [resourceId: number]: number };
  startElementValues: { [elementId: number]: number };
  startIndexValues: { [indexId: number]: number };

  rounds: SimulationRoundItem[];
}

interface SimulationRoundItem {
  startResourceValues?: { [resourceId: number]: number };
  startElementValues?: { [elementId: number]: number };
  startIndexValues?: { [indexId: number]: number };

  resourceValues?: { [resourceId: number]: number };
  elementValues?: { [elementId: number]: number };
  indexValues?: { [indexId: number]: number };
}

export default migration;
